import { request } from 'umi';

/** hm -- 自定义页面 -- 查询所有开启状态的自定义页面
 * 接口地址：https://www.apifox.cn/web/project/1822157/apis/api-45995190
 * GET /hm/custom_page/list/all
 */
export async function fetchCustomPageList() {
  return request('/hm/custom_page/list/all')
}

/** hm -- 自定义页面 -- 根据id查询自定义页面【B端】
 * 接口地址：https://www.apifox.cn/web/project/1822157/apis/api-45995185
 * GET /hm/custom_page/api/getById
 * @param {Number} pageId   *页面id
 */
export async function fetchCustomPageInfo(params: { pageId: number }) {
  return request('/hm/custom_page/api/getById', {
    params
  })
}
